import { RouteConfig } from 'vue-router';

import Search from '~/views/Search';

const config: RouteConfig = {
  component: Search,
  path: ':destination/:area',
};

export default config;
